import { JSX, useEffect } from 'react'
import { useActorRef } from '@xstate/react'
import {
    standardDraftsListStateMachine,
    StateMachineStatesExtension,
} from '@isdd/metais-common/components/state-machine/standardDraftsListStateMachine'
import { ApiStandardRequest } from '@isdd/metais-common/api/generated/standards-swagger'

import { StandardDraftsStateMachineContext } from '@/pages/standardization/draftslist/[entityId]/form'

interface IDraftsListStateMachineWrapper {
    children: JSX.Element
    data: ApiStandardRequest | undefined
}

export const DraftsListStateMachineProvider = ({ children, data }: IDraftsListStateMachineWrapper) => {
    const actorRef = useActorRef(standardDraftsListStateMachine)

    useEffect(() => {
        const snapshot = actorRef.getSnapshot()
        const currentState = snapshot?.value

        if (data?.standardRequestState && currentState === StateMachineStatesExtension.FETCHING) {
            actorRef.send({ type: data.standardRequestState })
        }
    }, [data?.standardRequestState, actorRef])

    return <StandardDraftsStateMachineContext.Provider value={actorRef}>{children}</StandardDraftsStateMachineContext.Provider>
}
